import React from 'react';
import { Helmet } from 'react-helmet';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import SaveMessage from 'components/SaveMessage';
import RoleButton from 'components/RoleButton';

import { ADMIN, MANAGER, PAYROLL } from 'components/RoleGate/constants';
import { CREATE_MODAL_QUERY_STRING_PARAM } from 'components/VirtualizedTable/constants';

// Child Components
// @ts-ignore
import TimesheetHolidaysVirtualizedTable from './components/TimesheetHolidaysVirtualizedTable';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const TimesheetHolidays = (): React.ReactElement => (
    <ErrorBoundary
        namespace="TimesheetHolidays"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>Holidays - {REACT_APP_PROJECT_NAME}</title>
        </Helmet>
        <PageTitleAndFilters
            title="Holidays"
            searchInputPlaceholder="Search holidays"
            hideFilters
            MessageComponent={
                <SaveMessage
                    namespace={[
                        'TIMESHEET_HOLIDAY_CREATE',
                        'TIMESHEET_HOLIDAY_UPDATE'
                    ]}
                />
            }
            FirstActionButton={
                <RoleButton
                    requiredRoles={[ADMIN, MANAGER, PAYROLL]}
                    params={{
                        [CREATE_MODAL_QUERY_STRING_PARAM]: true
                    }}
                    buttonProps={{
                        secondary: true,
                        style: {
                            marginRight: 0,
                            marginLeft: 8
                        }
                    }}
                >
                    Create New
                </RoleButton>
            }
        />

        <PageTitleAndFiltersPusher>
            <TimesheetHolidaysVirtualizedTable tableId="timesheet-holidays" />
        </PageTitleAndFiltersPusher>
    </ErrorBoundary>
);

export default TimesheetHolidays;
